import { Button, DialogState, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { useEffect, useState } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { TaskAssigneeField } from '../editTask/taskAssigneeField';
import { isNotBlank } from '@roc/feature-utils';
import { TaskStatus, TaskStatusDB } from '../../types/generalTasksTypes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    badge: {
      marginRight: '5px',
    },
  }),
);

type AssignToOwnerDialogProps = {
  open: boolean;
  taskId: number;
  currentStatus: string;
  handleClose: () => void;
};

export const AssignToOwnerDialog = observer(({ open, currentStatus, taskId, handleClose }: AssignToOwnerDialogProps) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const classes = useStyles();
  const [description, setDescription] = useState<string>('');
  const [errorText, setErrorText] = useState<string>('');

  useEffect(() => {
    if (open) {
      editTaskStore.reloadTaskById(taskId);
      setErrorText('');
      setDescription('');
    }
  }, [open]);

  const handleAssignConfirmation = () => {
    if (!description) {
      setErrorText('Please enter a reason.')
    } else {
      let status = TaskStatusDB.MORE_INFO_NEEDED;
      if (currentStatus === TaskStatusDB.NOT_APPLICABLE || currentStatus === TaskStatus.NOT_APPLICABLE) {
        status = TaskStatusDB.PENDING;
      }

      generalTasksStore.assignTaskToOwner(taskId, status, description, handleClose);
    }
  }

  const handleOnChange = (e) => {
    setErrorText('');
    setDescription(e.target.value);
  }

  return (
    <>

      <StandardDialog
        open={open}
        title='Assign To Sales'
        maxWidth='sm'
        handleClose={() => { handleClose() }}
        dialogContent={<Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              type={'text'}
              testId={'assignToOwner-description'}
              variant={'outlined'}
              standaloneLabel={true}
              label={'Reason: '}
              value={description}
              onChange={handleOnChange}
              fullWidth
              multiline={true}
              required={true}
              minRows={3}
              maxRows={3}
              error={isNotBlank(errorText)}
              helperText={errorText}
            />
          </Grid>
        </Grid>}
        dialogActions={
          <>
            <Button
              style={{ marginRight: '8px' }}
              onClick={() => { handleClose() }}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={handleAssignConfirmation}
              color="primary"
              variant="contained"
              testId="confirm"
            >
              Submit
            </Button>
          </>
        }
      />
    </>

  );
});
